import React from 'react';
import { Icon } from '@beeline.com/bp-design-system';

type MatchIconProps = {
  isChecked: boolean;
  style?: React.CSSProperties;
  className?: string;
};

export const MatchIcon = ({ isChecked, style, className }: MatchIconProps) => {
  return isChecked ? (
    <Icon
      dataTest="column-checkmark"
      data-checked
      name="check_circle"
      style={style}
      className={className}
      color="colorSuccess"
    />
  ) : (
    <Icon dataTest="column-checkmark" style={{ opacity: 0.3, ...style }} className={className} name="circle" />
  );
};
